import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { isMobileUA } from 'dpl/shared/utils';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import Icon from 'dpl/common/components/Icon';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

const IS_MOBILE = isMobileUA();

function Content() {
  const termsUrl = 'https://www.klarna.com/us/legal/';

  return (
    <div className="ph16-lg pv14-lg ph5 pb6 pt2">
      <div className="ph3 pv3 br-100 bg-gray-200 max-content mb1">
        <Icon name="klarna-k" height="24px" width="24px" />
      </div>
      <p
        className={classnames('lh-title font-serif mb2', {
          'font-18': IS_MOBILE,
          'font-32': !IS_MOBILE
        })}
      >
        Pay over time with Klarna
      </p>
      <p className="secondary font-14 lh-body mb4">
        Pay for your puppy over time with Klarna&apos;s flexible payment
        options. At checkout, choose &apos;Pay later with Klarna&apos; to split
        your total final payment into four interest-free installments for
        amounts under $2,000 or opt for monthly financing on amounts over
        $2,000. Deposits require full payment and cannot be financed. Your
        payment plan will be confirmed based on your purchase total and
        eligibility.
      </p>
      <p className="font-12 lh-title tertiary">
        A higher initial payment may be required for some consumers. CA resident
        loans made or arranged pursuant to a California Financing Law
        license.&nbsp;
        <a
          className="underline"
          href={termsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          See payment terms
        </a>
      </p>
    </div>
  );
}

function BuyNowPayLaterModal({ isOpen, onClose }) {
  if (IS_MOBILE) {
    return (
      <FixedTooltipPortal isVisible={isOpen} onCloseClick={onClose}>
        <Content />
      </FixedTooltipPortal>
    );
  }

  if (!IS_MOBILE && isOpen) {
    return (
      <MiniOverlayModal maxWidth="600px" onCloseClick={onClose}>
        <Content />
      </MiniOverlayModal>
    );
  }

  return null;
}

BuyNowPayLaterModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

BuyNowPayLaterModal.defaultProps = {
  isOpen: false
};

export default function BuyNowPayLaterDetails({ className, buttonCTA }) {
  const [isModalOpen, setModalOpen] = useState(false);

  function handleClick() {
    setModalOpen(true);
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: buttonCTA,
      view: ANALYTICS_VIEWS.PUPPY_PROFILE,
      view_feature: ANALYTICS_VIEW_FEATURE_LOCATIONS.PUPPY_DETAILS
    });
  }

  return (
    <>
      <button
        className={classnames('underline fw-normal', className)}
        type="button"
        onClick={handleClick}
      >
        {buttonCTA}
      </button>
      <BuyNowPayLaterModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}

BuyNowPayLaterDetails.propTypes = {
  className: PropTypes.string,
  buttonCTA: PropTypes.string
};

BuyNowPayLaterDetails.defaultProps = {
  className: '',
  buttonCTA: 'Learn more'
};
